import React, { useState, useEffect } from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { supabase } from '../../supabaseClient';
import './FloatingContact.css';

const FloatingContact = () => {
  const { t } = useLanguage();
  const [messengerUrl, setMessengerUrl] = useState("https://m.me/MufaTamDao");

  useEffect(() => {
    const fetchMessengerUrl = async () => {
      if (!supabase) return;
      try {
        const { data, error } = await supabase
          .from('contact_info')
          .select('messenger_url')
          .eq('id', 1)
          .maybeSingle();

        if (error) throw error;
        if (data?.messenger_url) {
          setMessengerUrl(data.messenger_url);
        }
      } catch (err) {
        console.error('Error fetching messenger URL:', err);
      }
    };

    fetchMessengerUrl();

    let channel = null;
    if (supabase) {
      channel = supabase
        .channel('floating-messenger-changes')
        .on('postgres_changes', { event: '*', schema: 'public', table: 'contact_info' }, fetchMessengerUrl)
        .subscribe();
    }

    return () => {
      if (channel && supabase) {
        supabase.removeChannel(channel);
      }
    };
  }, []);

  return (
    <div className="floating-contact-wrapper">
      <a
        href={messengerUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="floating-contact-btn"
        aria-label="Chat qua Messenger"
      >
        {/* Pulse rings background effect */}
        <span className="pulse-ring"></span>
        <span className="pulse-ring delay"></span>

        {/* Floating Icon Box */}
        <div className="icon-box">
          {/* Messenger Icon */}
          <svg
            className="messenger-icon"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path d="M12 2C6.477 2 2 6.145 2 11.258c0 2.91 1.45 5.517 3.715 7.222V22l3.415-1.874c.91.252 1.878.39 2.87.39 5.523 0 10-4.145 10-9.258C22 6.145 17.523 2 12 2zm1.066 12.443l-2.55-2.72-4.977 2.72 5.474-5.81 2.617 2.72 4.91-2.72-5.474 5.81z" />
          </svg>
        </div>

        {/* Hover Label / Tooltip */}
        <span className="contact-label">{t('floating_chat_label')}</span>
      </a>
    </div>
  );
};

export default FloatingContact;
